import { configureStore } from '@reduxjs/toolkit';
import {
    feedBackSlice,
    notificationModalSlice,
} from './slices/function/feedback';
import {
    sideBarSlice,
    backofficeTabsSlice,
} from './slices/function/sideBar-filterTabSlice';
import { authSlice, companySlice } from './slices/function/loginSlice';
import { backofficeApi } from './api/backoffice/backofficeApi';
import { backofficeDetailApi } from './api/backoffice/backofficeDetailApi';
import { backofficeContactApi } from './api/backoffice/backofficeContactApi';
import { pcaSlice } from './slices/function/pca';
import { backofficeCompaniesSlice } from './slices/backoffice/backofficeCompaniesSlice';
import { backofficeCompanySlice } from './slices/backoffice/backofficeCompanyDetailSlice';
import { backofficeSelectedCompaniesSlice } from './slices/backoffice/backofficeSelectedCompaniesSlice';
import { backofficeCompanyContactsSlice } from './slices/backoffice/backofficeCompanyContactsSlice';
import { adminAuthApi } from './api/auth/adminAuthApi';
import { backofficeCompanyAccessSlice } from './slices/backoffice/backofficeCompanyAccessSlice';
import { tenantsApi } from './api/tenants/tenantsApi';
import { permissionsApi } from './api/permissions/permissionsApi';

export const store = configureStore({
    reducer: {
        [sideBarSlice.reducerPath]: sideBarSlice.reducer,
        [pcaSlice.reducerPath]: pcaSlice.reducer,
        [feedBackSlice.reducerPath]: feedBackSlice.reducer,
        [notificationModalSlice.reducerPath]: notificationModalSlice.reducer,
        [authSlice.reducerPath]: authSlice.reducer,
        [companySlice.reducerPath]: companySlice.reducer,
        [backofficeTabsSlice.reducerPath]: backofficeTabsSlice.reducer,
        [backofficeCompaniesSlice.reducerPath]: backofficeCompaniesSlice.reducer,
        [backofficeApi.reducerPath]: backofficeApi.reducer,
        [backofficeContactApi.reducerPath]: backofficeContactApi.reducer,
        [backofficeDetailApi.reducerPath]: backofficeDetailApi.reducer,
        [backofficeSelectedCompaniesSlice.reducerPath]:
        backofficeSelectedCompaniesSlice.reducer,
        [backofficeCompanySlice.reducerPath]: backofficeCompanySlice.reducer,
        [backofficeCompanyContactsSlice.reducerPath]:
        backofficeCompanyContactsSlice.reducer,
        [adminAuthApi.reducerPath]: adminAuthApi.reducer,
        [backofficeCompanyAccessSlice.reducerPath]:
        backofficeCompanyAccessSlice.reducer,
        [tenantsApi.reducerPath]: tenantsApi.reducer,
        [permissionsApi.reducerPath]: permissionsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            backofficeApi.middleware,
            backofficeDetailApi.middleware,
            backofficeContactApi.middleware,
            adminAuthApi.middleware,
            tenantsApi.middleware,
            permissionsApi.middleware,
        ),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
